// Mission step 4: Summary and preview
// Displays a preview of the mission before final submission
// CREATED: Part of unified MissionModal architecture

import type { TaskItem } from '../../lib/supabase';
import type { RecurrenceConfig } from './RecurrenceConfigForm';
import { MissionPreview } from './MissionPreview';

interface MissionStep4SummaryProps {
  name: string;
  description: string;
  duration: number | null;
  serviceName?: string;
  items: TaskItem[];
  isRecurrent: boolean;
  recurrenceConfig: RecurrenceConfig;
}

export function MissionStep4Summary({
  name,
  description,
  duration,
  serviceName,
  items,
  isRecurrent,
  recurrenceConfig,
}: MissionStep4SummaryProps) {
  // Convert TaskItem[] to the format expected by MissionPreview
  const getTasksForPreview = () => {
    return items.map(item => ({
      name: item.title,
      description: '',
      has_free_field: item.requires_text_input || false,
      free_field_label: null,
      free_field_mandatory: item.is_text_input_required || false,
      order_index: item.order_index
    }));
  };

  // Get recurrence data for preview
  const getRecurrenceForPreview = () => {
    if (!isRecurrent) return undefined;

    return {
      frequency: recurrenceConfig.frequency,
      interval: recurrenceConfig.interval,
      daysOfWeek: recurrenceConfig.daysOfWeek,
      endMode: recurrenceConfig.endMode,
      endDate: recurrenceConfig.endDate,
      endOccurrences: recurrenceConfig.endOccurrences
    };
  };

  return (
    <div className="space-y-5 animate-fade-in">
      <MissionPreview
        name={name}
        description={description}
        durationMinutes={duration || 0}
        serviceName={serviceName}
        tasks={getTasksForPreview()}
        recurrence={getRecurrenceForPreview()}
      />
    </div>
  );
}
